const weathercodes = {
    0: 'Cielo despejado',
    1: 'Cielo principalmente despejado',
    2: 'Cielo parcialmente cubierto',
    3: 'Cielo nublado',
    45: 'Niebla',
    48: 'Niebla y escarcha',
    51: 'Llovizna ligera',
    53: 'Llovizna moderada',
    55: 'Llovizna densa',
    56: 'Llovizna helada ligera',
    57: 'Llovizna helada densa',
    61: 'Lluvia ligera',
    63: 'Lluvia moderada',
    65: 'Lluvia fuerte',
    66: 'Lluvia helada ligera',
    67: 'Lluvia helada fuerte',
    71: 'Nieve ligera',
    73: 'Nieve moderada',
    75: 'Nieve fuerte',
    77: 'Copos de nieve',
    80: 'Chubascos de lluvia ligera',
    81: 'Chubascos de lluvia moderada',
    82: 'Chubascos de lluvia fuerte',
    85: 'Chubascos de nieve ligera',
    86: 'Chubascos de nieve fuerte',
    95: 'Tormenta ligera o moderada',
    96: 'Tormenta con granizo ligera',
    99: 'Tormenta con granizo fuerte'
}
export default weathercodes;